import { createFileRoute } from '@tanstack/react-router';
import TerminalContactCreateView from '../terminal/ManageTerminalContactsView/components/TerminalContactCreateView';
export const Route = createFileRoute('/terminals/locations/$terminalId_/contacts/create')({
  component: TerminalContactCreateView,
});
